<template>
  <div class="corporateStyle">
  	<div class="aa" @click="aa()">
    </div>
    
    
    <!--企业风采列表-->
    <div v-if="detailShow" class="style-flex">
     
      <div class="row-flex col-md-4 col-sm-4" v-for="item in corporateList">
            <div>
              <img v-bind:src="item.img_url" @click="getStyleDetail(item.id)" alt="">
            </div>
            <p>{{item.title}}</p>
      </div>
      
    </div>

    
    
    <!-- 企业风采详情 -->
    <article v-if="detailShow==false" :model="dataListDetail" class="imgDetail">
        <p>{{dataListDetail.title}}</p>
        <img v-bind:src="dataListDetail.img_url"  alt="">
    </article>

    
    <br />
  </div>
</template>

<script>
export default {
  name: 'corporateStyle',
  data () {
    return {
      detailShow:true,
      corporateList:[],
      dataListDetail:{
      	title:'',
        img_url:''
      },
    }
  },
  created () {
  	this.getCorporateList();
  }
  ,
  methods:{
  	aa () {
      this.detailShow = true;
    },
  	getCorporateList () {
  		let self = this;
        const req = {
          index:1,
          size:10
        }
        this.$http.post('mien/pageSelect/'+req.index+'/'+req.size,{}).then((data)=>{
          if(data.body.success){
              for(var i in data.body.data){
                self.corporateList.push(data.body.data[i])
              }
          }
        })
  	},
  	getStyleDetail (id) {//根据id查询
  		this.detailShow = false;
  		
  		let self = this;
	    const req = {
	      index:1,
	      size:10
	    }
	    this.$http.post('mien/pageSelect/'+req.index+'/'+req.size,{id:id}).then((data)=>{
	      data.body.data.forEach(element => {
          self.dataListDetail.img_url = element.img_url
          self.dataListDetail.title = element.title
        })
	    })
  	},
   
  },
  components:{

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
*{
  text-align: center;
  text-indent: 6px;
  font-family: 微软雅黑;
  letter-spacing: 1px;
  color: #2D2D2D;
  font-size: 13px;
  line-height: 26px;
}

.corporateStyle{
  padding-bottom: 50px;
}
.style-flex{
  /*display: flex;*/
}
.row-flex{
  /*flex: 1;*/
  padding: 15px;
}

.row-flex div{
  text-align: center;
  margin-bottom: 10px;
  border: 1px solid #EEEEEE;
}

.row-flex img{
  width: 70%;  
  margin: 15% auto;
}

/*详情*/
.imgDetail{
  /*padding: 60px;*/
}
.imgDetail img{
  width: 70%;
}


  .aa{
    width: 255px;
    height: 40px;
    background-color: red;
    position: absolute;
    left: -270px;
    top: 97px;
    opacity:0;
  }
</style>



// WEBPACK FOOTER //
// src/components/Introduce/corporateStyle.vue